module.exports = __webpack_public_path__ + "static/media/avatars_female_1.c455836e.png";